import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";

import { App } from "App";
import { isDev } from "common/utilities/environment";
import "fonts.css";
import internetExplorerFallback from "internetExplorerFallback.html?raw";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENVIRONMENT,
  debug: false,
  tracesSampleRate: 1.0,
  enabled: !isDev,
  sendDefaultPii: true,
});

const container = document.getElementById("root");
if (container === null) throw new Error('No element has ID "root".');

if (/msie|trident/i.test(navigator.userAgent)) container.innerHTML = internetExplorerFallback;
else createRoot(container).render(<App />);
